export function request( state ) {
    return state.set( 'switch-universe', 'IN_PROGRESS' );
}

export function error( state ) {
    return state.set( 'switch-universe', 'ERROR' );
}

export function finish( state ) {
    return state.set( 'switch-universe', 'FINISHED' );
}
